export function buildInstallPostbackUrl(postbackTemplate: string): string | null {
    const currentPageParams = new URL(window.location.href).searchParams;

    const filledTemplate = postbackTemplate.replace(/\{([^}]+)\}/g, (_, placeholder) => {
        const paramValue = currentPageParams.get(placeholder);
        return paramValue != null ? encodeURIComponent(paramValue) : "";
    });

    try {
        const postbackUrlObject = new URL(filledTemplate);

        postbackUrlObject.searchParams.forEach((_, paramName) => {
            if (paramName === "from") {
                postbackUrlObject.searchParams.set("from", "ducksay-pwa");
            } else if (currentPageParams.has(paramName)) {
                postbackUrlObject.searchParams.set(paramName, currentPageParams.get(paramName)!);
            }
        });
        console.log('postbackUrlObject', postbackUrlObject)
        return postbackUrlObject.toString();
    } catch (error) {
        console.error('Error building custom install postback URL:', error);
        return null;
    }
}
